import React from 'react';
import {
    tradeSellerLinks,
    companyLinks,
    visitLinks,
    sitemapLinks,
    connectLinks,
} from './Footer/links';
import { FormattedMessage } from 'react-intl';

export const linkColumnConfig = [
    {
        title: (
            <FormattedMessage id="footer.tradeAndSellers.title" defaultMessage="Trade & Sellers" />
        ),
        items: tradeSellerLinks,
        columns: 2,
    },
    {
        title: <FormattedMessage id="footer.ourCompany.title" defaultMessage="Our Company" />,
        items: companyLinks,
        columns: 2,
    },
    {
        title: <FormattedMessage id="footer.visitUs.title" defaultMessage="Visit Us" />,
        items: visitLinks,
        columns: 2,
    },
    {
        title: <FormattedMessage id="footer.categories.title" defaultMessage="Categories" />,
        items: sitemapLinks,
        columns: 2,
        enablerKey: 'isSiteMapsEnabled',
    },
    {
        title: <FormattedMessage id="footer.connect.title" defaultMessage="Connect With Us" />,
        items: connectLinks,
        columns: 4,
    },
];

export const filterLinks = (links, viewer) => {
    return links.filter(link => {
        if (
            (link.enablerKey && viewer[link.enablerKey] === false) ||
            (link.disablerKey && viewer[link.disablerKey] === true)
        ) {
            return null;
        }
        return link;
    });
};
